import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import Loading from './Loading';

// Decide before rendering the lazy checkout child, so an empty visit never
// downloads checkout/Stripe merely to redirect back to event discovery.
// Recovery links use their separate existing route and renew the cart there.
export default function CheckoutEntry({ children }) {
  const { cart, loading } = useCart();
  if (cart) return children;
  if (loading) return <Loading page text="Loading checkout..." />;
  return <Navigate to="/events" replace />;
}
